// services/CitySponsorService.js

import httpService from "./httpService";
import { assertRequired, getWithQuery } from "@/services/utils/requestHelpers";

const LevelService = {
    getMapAll: async (props) => {
        return await getWithQuery(httpService, "levels-all", props);
    },
    getAll: async (props) => {
        return await getWithQuery(httpService, "levels", props);
    },
    create: async (payload) => {
        return await httpService.post("levels/create", payload);
    },
    update: async (payload) => {
        const { id } = payload || {};
        assertRequired(id, "Level ID is required for update");
        return await httpService.put(`levels/update/${id}`, payload);
    },
    delete: async (id) => {
        assertRequired(id, "Level ID is required for deletion");
        return await httpService.delete(`levels/${id}`);
    },
};

export default LevelService;
